import { render, staticRenderFns } from "./RedCross.vue?vue&type=template&id=540c1802&scoped=true&"
import script from "./RedCross.vue?vue&type=script&lang=js&"
export * from "./RedCross.vue?vue&type=script&lang=js&"
import style0 from "./RedCross.vue?vue&type=style&index=0&id=540c1802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c1802",
  null
  
)

export default component.exports